import React from 'react'
import LookupList from './LookupList'

const LookupManagement = () => {
    return <LookupList />
}

export default LookupManagement
